<template>
  <div class="fill-height empty-state__background pa-0">
    <v-container class="empty-state__container fill-height pa-0">
      <div class="empty-state" no-gutters>
        <v-row no-gutters>
          <v-col cols="12" align-self="center" class="mb-4">
            <v-col cols="2" offset="5" class="pa-0">
              <v-img :src="EmptyState"></v-img>
            </v-col>
          </v-col>
          <v-col cols="12" align-self="center" class="mb-1">
            <v-row no-gutters align="center" justify="center">
              <span
                class="body-regular-large neutral-20-dark--text text-center"
                >{{ $t(i18nPath + 'videoInTrash.title') }}</span
              >
            </v-row>
          </v-col>
          <v-col cols="12" align-self="center" class="mb-4">
            <v-row no-gutters align="center" justify="center">
              <span
                class="body-regular-small neutral-40-light--text text-center"
                v-html="
                  $t(`${i18nPath}videoInTrash.description`, {
                    remainingDays: formattedMessage,
                  })
                "
              ></span>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row no-gutters align="center" justify="center">
              <base-btn type="primary" @click="redirectToTrash">{{
                $t(i18nPath + 'videoInTrash.action')
              }}</base-btn>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>
<script>
import EmptyState from '@/assets/emptyState/empty-state.svg'
export default {
  name: 'VideoInTrash',
  components: {
    BaseBtn: () => import('@/components/BaseBtn.vue'),
  },
  props: {
    videoInTrashData: {
      required: true,
    },
  },
  data() {
    return {
      EmptyState,
      i18nPath: 'message.pages.videoPage.emptyState.',
    }
  },
  computed: {
    remainingDaysToBeRemoved() {
      const start = new Date()
      const end = new Date(this.videoInTrashData.updated_at)
      const diffTime = Math.abs(end - start)
      let daysLeft = 30 - Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return daysLeft < 1 ? 1 : daysLeft
    },
    formattedMessage() {
      const dayText = ' ' + this.$i18next.t(this.i18nPath + 'videoInTrash.day')
      const plural = this.remainingDaysToBeRemoved > 1 ? 's' : ''
      return this.remainingDaysToBeRemoved + dayText + plural
    },
  },
  methods: {
    redirectToTrash() {
      this.$router.push({ name: 'Trash' })
    },
  },
}
</script>
<style lang="scss" scoped>
.empty-state__background {
  display: flex;
  align-items: center;
  background-color: varFigma(neutral-background);

  .empty-state__container {
    max-width: unset !important;
    background-color: varFigma(neutral-100-white);
    border-radius: $spacing-03;
    margin: $spacing-07;
    width: calc(100% - 48px);
    height: calc(100% - 48px);
    justify-content: center !important;

    .empty-state {
      background-color: varFigma(neutral-100-white);
    }
  }
}
.neutral-20-dark--text {
  color: varFigma(neutral-20-dark);
}
.neutral-50-light--text {
  color: varFigma(neutral-50-light);
}
</style>
